/* eslint-disable max-len, no-trailing-spaces */
import React from 'react';

export default function Privacy() {
  return (
    <div
      className="privacy-policy"
    >
      <h1 className="heading heading--1">Privacy Policy</h1>

      <p>Last updated on 5th May 2018</p>

      <p>
        This privacy policy forms part of an agreement between you and Failbetter Games Ltd

        {' '}
        (referred to in these terms as "Failbetter Games", "we", "our" and "us")

        {' '}
        and applies to your use of its database, websites and other channels and technologies;

        {' '}
        when this privacy policy mentions "StoryNexus" or "the Service", this includes all of these things.

        {' '}
      </p>

      <h2 className="heading heading--2">
        Introduction

      </h2>

      <ol>
        <li>
          Failbetter Games is committed to protecting and respecting your privacy.

        </li>

        <li>
          This privacy policy sets out the basis on which we will process any personal information as well as

          {' '}
          certain other information we collect from you, or that you provide to us.

          {' '}
          Please read this privacy policy carefully so that you understand how we will treat your information.
        </li>
      </ol>

      <h2 className="heading heading--2">
        Children

      </h2>

      <ol>
        <li>
          We recognise we have a special obligation to protect personal information we obtain from children.

          {' '}
          We do not and will not knowingly collect information from any unsupervised child under the age of 13.

          {' '}
          In certain countries, prior written permission or other verifiable consent may also be required from a

          {' '}
          parent or guardian for children under the age of 18.
        </li>
      </ol>

      <h2 className="heading heading--2">
        The data controller

      </h2>

      <ol>
        <li>
          For data collection purposes, the data controller is Failbetter Games Limited, a company registered

          {' '}
          in England and Wales with number 07121579.
        </li>
      </ol>

      <h2 className="heading heading--2">
        Information we may collect from you

      </h2>

      <ol>
        <li>
          We respect your right to privacy and will only process personal information you provide to us in

          {' '}
          accordance with applicable privacy laws, such as the Privacy and Electronic Communications

          {' '}
          (EC Directive) Regulations 2003 and GDPR within the EU.
        </li>

        <li>
          The kinds of data which we may process in order to monitor our Service and improve your user experience include:

          <ul>
            <li>
              Your email address.

            </li>
            <li>
              Your screen name and profile picture.

            </li>
            <li>
              Technical or other details about any device which you use to access the services:

              {' '}
              Internet and/or network connection (including your IP address, Media Access Control (MAC),

              {' '}
              operating system, browser type or hardware).
            </li>
            <li>
              Details of your use of the Service including, but not limited to: traffic data, IP address, the Service resources that you access, the time you spend on the Service, crash reports and reasons for interrupted connections.

            </li>
          </ul>
        </li>

        <li>
          We may collect and process data about you through the following means:

          <ul>
            <li>Data that you provide to us as part of obtaining access to our Services (for example, signing up for an account, or providing a support email address).</li>
            <li>Information provided when you report a problem with any of the Services.</li>
            <li>We may also ask you to complete surveys that we use for research purposes, although you do not have to respond to them.</li>
          </ul>
        </li>

        <li>We may collect this data through our Services or third party services connected with them.</li>
        <li>We may store the data that we collect from you on servers outside the EU.  It may also be processed by staff operating outside of the EEA who work for us or for one of our suppliers.  Such staff may be engaged in, among other things, the performance of our obligations from any contracts entered into with you and the provision of support services.  By submitting your personal data, you agree to this transfer, storing or processing.  We will take all steps reasonably necessary to ensure that your data is treated securely and in accordance with this privacy policy, and will only share it with partners committed to GDPR compliance.</li>
      </ol>

      <h2 className="heading heading--2">
        Cookies

      </h2>

      <ol>
        <li>
          Our website uses cookies, small files which stay on your device. Some are essential for these sites to work — without cookies, you wouldn't be able to log in.
          
          <p>We also use cookies to provide enhanced functionality, like the ability to hide announcements.</p>
          <p>We also use Google Analytics to gather anonymous information about how our sites are used and how visitors find them. If you'd prefer not to be tracked by Google Analytics, you can opt out there.</p>
        </li>
      </ol>

      <h2 className="heading heading--2">
        Uses made of your information

      </h2>

      <ol>
        <li>
          We use information held about you in the following ways:
          
          <ul>
            <li>To authenticate with the service: this may include email address, password, Twitter authentication name and tokens, Facebook authentication name and tokens. We do not share this information with third parties.</li>
            <li>To ensure that content from the Service is presented in the most effective manner for you and for your computer or other device from which you access the Service.</li>
            <li>To provide you with information or services that you request from us or which we feel may interest you, if you have consented to being contacted for such purposes.</li>
            <li>To perform our obligations from any contracts entered into with you.</li>
            <li>To allow you to participate in interactive features of our Service, if you choose.</li>
            <li>To notify you about changes to our Service.</li>
            <li>We may use your authentication information to find your contacts on social networks, and allow you to invite them to join you in the Service. We will not do this without your active consent.</li>
            <li>We may use your authentication information to allow you to message other users. We will not do this without your active consent.</li>
          </ul>
        </li>

        <li>Please remember that any communications you have via our Service may reveal details about you, including for example your account name and/or the content of your communications to other users.</li>

        <li>We are not responsible for the activities of other users or other third parties to whom you choose to provide your personal information (whether via our Service or otherwise).</li>
      </ol>


      <h2 className="heading heading--2">
        Disclosure of your information

      </h2>

      <ol>
        <li>We may disclose your personal information to any member of our existing or future group, which means our subsidiaries, our ultimate holding company and its subsidiaries.</li>
        <li>
          We may disclose your personal information to third parties in the following circumstances:
          
          <ul>
            <li>In the event that we sell any business or assets, in which case we may disclose your personal information to the buyer of such business or assets.</li>
            <li>If we or substantially all of our assets are acquired by a third party, in which case personal information held by us about our customers will be a transferred asset.</li>
            <li>If we are under a duty to disclose or share your personal information in order to comply with any legal obligation, or in order to enforce or apply our terms; or to protect our rights, property, or the safety of our customers or of others.</li>
            <li>We may share aggregated information that does not include personal information for industry analysis, demographic profiling and other purposes. Any information shared in these contexts will be anonymised.</li>
          </ul>
        </li>

        <li>16.  We will not use your information for third party marketing purposes.</li>
      </ol>

      <h2 className="heading heading--2">
        Third party sites

      </h2>

      <ol>
        <li>Our Services may, from time to time, contain links to and from the websites of our partner networks, advertisers and affiliates.  These websites have their own privacy policies.  Please note that if you follow a link to any of these websites, we do not accept any responsibility or liability for these policies, nor do we endorse such websites.</li>
      </ol>

      <h2 className="heading heading--2">
        Your rights

      </h2>

      <ol>
        <li>You can email us at support@failbettergames.com to request that we delete your personal information. We will honour such requests, unless we need to keep that information for legitimate business or legal reasons.  We may also not immediately remove information from backup systems designed to protect our services against accidental or malicious destruction.</li>
      </ol>

      <h2 className="heading heading--2">
        Data security

      </h2>

      <ol>
        <li>Unfortunately, the transmission of information via the Internet is not completely secure. We will do our best to protect your personal information but we cannot guarantee the security of your data transmitted to our Services — any transmission is at your own risk. We will use procedures and security features to try to prevent unauthorised access to your information.</li>
      </ol>

      <h2 className="heading heading--2">
        Changes to our privacy policy

      </h2>

      <ol>
        <li>Any changes we may make to our privacy policy in the future will be posted on this page and, where appropriate, brought to your attention via email.  We will indicate the changes clearly.</li>
      </ol>

      <h2 className="heading heading--2">
        Contact information

      </h2>

      <ol>
        <li style={{ textAlign: 'left' }}>
          Please address any questions or comments regarding this privacy policy to

          {' '}
          <a href="mailto:enquiries@failbettergames.com">enquiries@failbettergames.com</a>
          .
        </li>
      </ol>
    </div>
  );
}

Privacy.displayName = 'Privacy';
